import React, { useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { Checkbox } from "../primitives";
import { colors } from "../../../utils/styles";

export default function ConfirmationPopup({
  title,
  children,
  checkboxLabel,
  confirmLabel,
  busyLabel,
  busy = false,
  confirmColor = "primary",
  onConfirm,
  onCancel
}) {
  const [checked, setChecked] = useState(false);

  return (
    <>
      <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: colors.navy }}>{title}</h1>
      <div style={{ margin: "12px 0 0", fontSize: 14, color: colors.text, lineHeight: 1.6 }}>{children}</div>
      <div style={{ margin: "16px 0" }}>
        <Checkbox
          label={checkboxLabel}
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          disabled={busy}
        />
      </div>
      <DialogActions sx={{ px: 0, pt: 1 }}>
        {onCancel && (
          <Button onClick={onCancel} disabled={busy} variant="outlined">
            Cancel
          </Button>
        )}
        <Button onClick={onConfirm} disabled={!checked || busy} variant="contained" color={confirmColor}>
          {busy && busyLabel ? busyLabel : confirmLabel}
        </Button>
      </DialogActions>
    </>
  );
}
